import {HttpClientManager, convertToJson, parseJsonToObject, Identity} from 'wc-lib';
import {ChangePasswordResponse} from './interface/change-password';
import Config from './config';

export class Service {
  static http: any = HttpClientManager.httpClient();

  static async authenticateIwa(): Promise<Identity> {
    const response = await this.http.fetch(Config.identityUrl);
    return await response.json();
  }

  static async authenticate(userId: string, password: string): Promise<Identity> {
    // Base64 encode user ID and password
    let authorisationEncoded = btoa(`${userId}:${password}`);
    const response = await this.http.fetch(Config.identityUrl, {
      headers: new Headers({
        "Authorization": `Basic ${authorisationEncoded}`
      })
    });
    return await response.json();
  }

  static async signOut(): Promise<Identity> {
    const response = await this.http.fetch('/api/auth/logout');
    return await response.json();
  }

  static async changePassword(oldPassword: string, newPassword: string): Promise<ChangePasswordResponse> {
    const response = await this.http.fetch('/api/auth/AemoPortal/ChangePassword', {
      method: 'post',
      body: convertToJson({
        OldPassword: oldPassword,
        NewPassword: newPassword
      })
    });
    return await response.json();
  }

  static async getMenuItems(): Promise<any> {
    const response = await this.http.fetch(`/api/v1/portal/MenuItems?RootMenuItem=${Config.rootMenuItem}`);
    return await response.json();
  }

  static async getParticipants(): Promise<any> {
    const response = await this.http.fetch('/api/v1/portal/Participants');
    try {
      return await response.json();
    } catch {
      return { data: { participantList: [] } };
    }
  }

  static async setParticipant(actingParticipantId: string): Promise<any> {
    try {
      const response = await this.http.fetch('/api/v1/portal/SetParticipant', {
        method: 'post',
        body: convertToJson({
          ActingParticipantId: actingParticipantId
        })
      });
      let jsonResponse = await response.json();
      return jsonResponse.data;
    } catch(error) {
      return {
        Result: false
      };
    }
  }

  static async getPersistentNotification(): Promise<any> {
    const response = await this.http.fetch(`/api/v1/portal/getPersistentNotification?RootMenuItem=${Config.rootMenuItem}`, {
      method: 'get'
    });
    let textResponse = await response.text();
    let jsonResponse = parseJsonToObject(textResponse, 'startDate', 'endDate');
    return jsonResponse.data;
  }

  static async getUnreadNotifications(lastReadDateTime: Date): Promise<any> {
    const response = await this.http.fetch(`/api/v1/portal/getUnreadNotifications`, {
      method: 'post',
      body: convertToJson({
        RootMenuItem: Config.rootMenuItem,
        LastReadDateTime: lastReadDateTime
      })
    });
    let textResponse = await response.text();
    let jsonResponse = parseJsonToObject(textResponse, 'startDate', 'endDate');
    return jsonResponse.data;
  }

  static async getNotifications(startIndex: number, endIndex: number): Promise<any> {
    const response = await this.http.fetch(`/api/v1/portal/getNotifications`, {
      method: 'post',
      body: convertToJson({
        RootMenuItem: Config.rootMenuItem,
        StartIndex: startIndex,
        EndIndex: endIndex
      })
    });
    let textResponse = await response.text();
    let jsonResponse = parseJsonToObject(textResponse, 'startDate', 'endDate');
    return jsonResponse.data;
  }

  static async getFavourites(): Promise<any> {
    const response = await this.http.fetch(`/api/v1/portal/getFavourites`, {
      method: 'post',
      body: convertToJson({
        RootMenuItem: Config.rootMenuItem,
      })
    });
    let textResponse = await response.text();
    let jsonResponse = parseJsonToObject(textResponse);
    return jsonResponse.data;
  }

  static async addFavourite(menuItemId: string): Promise<any> {
    const response = await this.http.fetch(`/api/v1/portal/addFavourite`, {
      method: 'post',
      body: convertToJson({
        RootMenuItem: Config.rootMenuItem,
        MenuItemId: menuItemId
      })
    });
    let textResponse = await response.text();
    let jsonResponse = parseJsonToObject(textResponse);
    return jsonResponse.data;
  }

  static async removeFavourite(menuItemId: string): Promise<any> {
    const response = await this.http.fetch(`/api/v1/portal/removeFavourite`, {
      method: 'post',
      body: convertToJson({
        RootMenuItem: Config.rootMenuItem,
        MenuItemId: menuItemId
      })
    });
    let textResponse = await response.text();
    let jsonResponse = parseJsonToObject(textResponse);
    return jsonResponse.data;
  }

  static async editFavourite(menuItemId: string, menuItemText: string): Promise<any> {
    const response = await this.http.fetch(`/api/v1/portal/editFavourite`, {
      method: 'post',
      body: convertToJson({
        RootMenuItem: Config.rootMenuItem,
        MenuItemId: menuItemId,
        MenuItemText: menuItemText
      })
    });
    let textResponse = await response.text();
    let jsonResponse = parseJsonToObject(textResponse);
    return jsonResponse.data;
  }

  static async editFavouriteOrder(menuItemId: string, order: number): Promise<any> {
    const response = await this.http.fetch(`/api/v1/portal/editFavouriteOrder`, {
      method: 'post',
      body: convertToJson({
        RootMenuItem: Config.rootMenuItem,
        MenuItemId: menuItemId,
        Order: order
      })
    });
    let textResponse = await response.text();
    let jsonResponse = parseJsonToObject(textResponse);
    return jsonResponse.data;
  }

  static async getMarketNotices() {
    const response = await this.http.fetch('https://aemo.com.au/aemo/apps/api/report/ELEC_NEM_SUMMARY', {
      method: 'get'
    });
    let textResponse = await response.text();
    let jsonResponse = parseJsonToObject(textResponse, 'EFFECTIVEDATE');
    return jsonResponse.ELEC_NEM_SUMMARY_MARKET_NOTICE;
  }
}



// WEBPACK FOOTER //
// src/service.ts